const breakpoints = ['576px', '768px', '992px', '1200px', '1400px'];

export const theme = {
    colors: {
        hover: '#ED2024',
        text: '#152637',
        white: '#fff',
        black: '#000',
        red: '#dc004e',
        primary: '#152637',
        blackTheme: 'rgb(29, 35, 39)',
        whiteTheme: 'rgb(237,232,229)',
        grayTheme: 'rgb(156, 160, 151)',
        bodyColor: '#ede8e5',
        themeColor700: 'rgba(33,33,33,0.7)',
        themeColor600: '#4D4D4D',
        themeColor500: '#EEE4D9',
        themeColor400: '#B29474',
        themeColor300: '#B8936D',
        themeColor200: '#CFAE8B',
        themeColor100: '#EBD8C3',
        themeColor50: '#E4E0DB'
    },
    fonts: {
        fontName: "PP Neue Montreal",
        body: 'PP Neue Montreal, Arial, Helvetica, freesans, sans-serif',
        heading: 'PP Neue Montreal',
    },
    fontSizes: {
        body: '20px',
        h1: '5rem',
        h2: '3.25rem',
        h3: '2rem',
        h4: '2rem',
        h5: '1.8rem',
        h6: '1.5rem',
    },
    letterSpacing: {
        body: '0',
        h1: '0',
        h2: '0',
        h3: '0',
        h4: '0',
        h5: '0',
        h6: '0',
    },
    fontWeights: {
        body: 400,
        medium: 500,
        semiBold: 600,
        regular: 400,
        light: 300,
        bold: 'bold'
    },
    lineHeights: {
        body: '1.2',
        h1: '5rem',
        h2: '3.75rem',
        h3: '2.25rem',
        h4: '2.25rem',
        h5: '2rem',
        h6: '1.2rem',
    },
    radius: {
        sm: '3px',
        md: '5px',
        lg: '8px',
        rounded: '4px',
        circle: '50%',
        pill: '500px',
    },
    shadows: {
        default: '0 0 12px 3px rgba(0, 0, 0, 0.06)',
        sm: '0px -1px 1px 0px rgba(0,0,0, .2)',
        lg: '0 1rem 3rem rgba(0, 0, 0, .175)',
        input: '0 0 0 0.2rem rgb(1 104 250 / 25%)',
    },
    breakpoints: [...breakpoints],
    transition: 'all 0.7s cubic-bezier(0.25, 0.74, 0.22, 0.99) 0s',
    transitionDelay: '0.5s',
    clippath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',

};